import BaseContentDetailsPageNavView from "scripts/views/baseContentDetailsPageNavView";
import templateContentDetailsImagePageNav from "templates/contentDetailsImagePageNav.hbs";
import L from "lodash/fp";

class ContentDetailsImagePageNavView extends BaseContentDetailsPageNavView {
  constructor(options) {
    super(options);
    this.organizationProperties = options.organizationProperties;
  }

  get template() {
    return templateContentDetailsImagePageNav;
  }

  render() {
    const modelProps = this.model.toJSON();

    this.$el.html(
        this.template(
            L.merge(
                {
                  showComments: !this.organizationProperties.hideCommentsTab
                },
                modelProps,
            ),
        ),
    );

    this.updateLinkState();
    this.updatePosition();

    return this;
  }
}

export default ContentDetailsImagePageNavView;
